import { FormControl, InputAdornment, OutlinedInput } from "@mui/material";
import React from "react";
import { Control, Controller, FieldValues } from "react-hook-form";

type Props = {
  restProps: any;
  errors: any;
  id: string;
  label?: string;
  control: Control<FieldValues, any>;
  min?: number;
  max?: number;
  onChange?: (value: number) => void;
  readOnly?: boolean;
};

const NumberPicker = ({
  errors,
  label,
  id,
  control,
  min,
  max,
  restProps,
  readOnly,
  onChange,
}: Props) => {
  return (
    <>
      <FormControl
        className={`flex flex-col w-full  h-12 ${restProps.className}`}
        variant="outlined"
        inputMode="numeric"
      >
        <label htmlFor={id} className="">
          {label}
        </label>
        <Controller
          name={id}
          control={control}
          render={({ field }) => {
            return (
              <OutlinedInput
                {...restProps}
                className="bg-white rounded-none"
                type="number"
                name={id}
                id={id}
                // sx={{
                //   "& fieldset": { border: "none" },
                // }}
                onBlur={field.onBlur}
                ref={field.ref}
                onChange={(event) => {
                  event.stopPropagation();

                  const value = event.target.value;
                  if (value === "" || Number(value) > 0) {
                    if (onChange) {
                      return onChange(Number(value));
                    }
                    field.onChange(Number(value));
                  }
                }}
                onWheel={(e) => e.preventDefault()} // Prevents wheel scrolling
                onScroll={(e) => e.preventDefault()} // Prevents scroll
                value={Number(field.value)}
                // defaultValue={min}
                inputProps={{
                  min,
                  max,
                  readOnly,
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <div className="flex flex-row justify-center items-center h-full">
                      <div
                        className="bg-white border-l px-2 h-4 cursor-pointer hover:bg-gray-300 flex justify-center items-center"
                        onClick={() => {
                          if (Number(field.value) - 1 < 0) {
                            return;
                          }
                          field.onChange(Number(field.value) - 1);
                        }}
                      >
                        <svg
                          className="w-3 h-3 text-gray-900"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 18 2"
                        >
                          <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M1 1h16"
                          />
                        </svg>
                      </div>
                      <div
                        onClick={() => field.onChange(Number(field.value) + 1)}
                        className="bg-white border-l px-2 h-4 cursor-pointer hover:bg-gray-300 flex justify-center items-center"
                      >
                        <svg
                          className="w-3 h-3 text-gray-900"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 18 18"
                        >
                          <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M9 1v16M1 9h16"
                          />
                        </svg>
                      </div>
                    </div>
                  </InputAdornment>
                }
              />
            );
          }}
        />
      </FormControl>
      <div className="text-red-600 text-sm cursor-default my-4 pt-3">
        {errors[id]?.message}
      </div>
    </>
  );
};

export default React.memo(NumberPicker);
